module.exports = __webpack_public_path__ + "fonts/MicrobrewThree.e2695afe56ac59b07548d4a719437b3d.woff2";